"use client";

import GridViewRounded from "@mui/icons-material/GridViewRounded";
import ViewListRounded from "@mui/icons-material/ViewListRounded";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";

export type ViewMode = "cards" | "list";

export type ViewToggleProps = {
  value: ViewMode;
  onChange: (value: ViewMode) => void;
  /** Aria-label du bouton grille — les deux boutons n'ont qu'une icône. */
  cardsLabel: string;
  /** Aria-label du bouton liste. */
  listLabel: string;
  /** Produit `${prefix}-toggle`, `${prefix}-cards` et `${prefix}-list`. */
  testIdPrefix?: string;
};

/**
 * Bascule grille / liste d'une page de catalogue.
 *
 * `exclusive` sans `null` possible : MUI émet `null` quand on reclique le
 * bouton déjà actif, et une liste doit toujours avoir une vue. Le composant
 * absorbe ce cas plutôt que de laisser chaque appelant écrire le même garde.
 */
export function ViewToggle({
  value,
  onChange,
  cardsLabel,
  listLabel,
  testIdPrefix,
}: ViewToggleProps) {
  return (
    <ToggleButtonGroup
      value={value}
      exclusive
      onChange={(_, next) => {
        if (next === "cards" || next === "list") onChange(next);
      }}
      size="small"
      data-testid={
        testIdPrefix === undefined ? undefined : `${testIdPrefix}-toggle`
      }
    >
      <ToggleButton
        value="cards"
        aria-label={cardsLabel}
        data-testid={
          testIdPrefix === undefined ? undefined : `${testIdPrefix}-cards`
        }
      >
        <GridViewRounded fontSize="small" />
      </ToggleButton>
      <ToggleButton
        value="list"
        aria-label={listLabel}
        data-testid={
          testIdPrefix === undefined ? undefined : `${testIdPrefix}-list`
        }
      >
        <ViewListRounded fontSize="small" />
      </ToggleButton>
    </ToggleButtonGroup>
  );
}
